const pending = new Map();

export function fetchPasswordStatus(token) {
  if (!token) return Promise.resolve(null);
  const hit = pending.get(token);
  if (hit) return hit;
  const req = fetch('https://api-hr.boonsiri.co.th/auth/password-status', {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => res.json())
    .catch(() => null);
  pending.set(token, req);
  return req;
}
